import React, {useContext, useEffect, useState} from "react";
import {Scenario, Stage, Step} from "../../api/model/scenario";
import {StageComponent} from "./Stage";
import {QuotationContext} from "../../contexts/QuotationContext";
import {ScenarioContext} from "../../contexts/ScenarioContext";
import {Quotation, quotationStatusList} from "../../model/quotation";
import { ProductType } from "../../api/model/common";

interface ScenarioComponentProps {
    scenario: Scenario,
    type?: ProductType
}

export const ScenarioComponent = ({scenario, type}: ScenarioComponentProps) => {
    const { quotation, setQuotation, saveTempValues } = useContext(QuotationContext);

    const [currentStage, setCurrentStage] = useState<Stage>(
        scenario.stages.find(value => value.quotationStatus === quotation?.status)
        ?? scenario.stages[0]
    );

    const getCurrentStep = () => {
        const searchedStep = localStorage.getItem(`${type}_step`) ? localStorage.getItem(`${type}_step`) : quotation?.currentStep
        return searchedStep && currentStage.steps.some(step => step.code === searchedStep) ? currentStage.steps.find(step => step.code === searchedStep) : currentStage.steps[0]
    }

    const [currentStep, setCurrentStep] = useState<Step>(getCurrentStep());

    const [previousQuotationStepCodesStack, setPreviousQuotationStepCodesStack] = useState<string[]>([]);

    const [previousStep, setPreviousStep] = useState<Step>(null);

    const nextStageHandler = (quotation: Quotation) => {
        const currentStageIndex = scenario.stages.indexOf(currentStage);
        const nextStage = scenario.stages[currentStageIndex + 1];
        setCurrentStage(nextStage);
        setCurrentStep(nextStage.steps[0]);
        window.scrollTo(0, 0);
    };

    const pushPreviousQuotationStepCode = (code: string) => {
        const previousQuotationStepCodesStackCopy = [...previousQuotationStepCodesStack];
        previousQuotationStepCodesStackCopy.push(code);
        setPreviousQuotationStepCodesStack(previousQuotationStepCodesStackCopy);
    };

    const popPreviousQuotationStepCode = () => {
        const previousQuotationStepCodesStackCopy = [...previousQuotationStepCodesStack];
        const code = previousQuotationStepCodesStackCopy.pop();
        setPreviousQuotationStepCodesStack(previousQuotationStepCodesStackCopy);
        return code;

    };

    const backStageHandler = (quotation: Quotation) => {
        const currentStageIndex = scenario.stages.indexOf(currentStage);
        const nextStage = scenario.stages[currentStageIndex - 1];
        setCurrentStage(nextStage);
        const currentStep = nextStage.steps[nextStage.steps.length - 1];
        setCurrentStep(currentStep);
        quotation.currentStep = popPreviousQuotationStepCode();
        quotation.id = quotation.id || null;
        quotation.status = quotationStatusList[currentStageIndex - 1];
        setQuotation(quotation);
        window.scrollTo(0, 0);
    };

    const [stepMessages, setStepMessages] = useState<Array<string>>([]);

    useEffect(() => {
        saveTempValues('step', currentStep.code)
    }, [currentStep])

    return (
        <div>
            <ScenarioContext.Provider
                value={{
                    currentStep,
                    setCurrentStep,
                    previousStep,
                    setPreviousStep,
                    nextStageHandler,
                    backStageHandler,
                    pushPreviousQuotationStepCode,
                    popPreviousQuotationStepCode,
                    stepMessages,
                    setStepMessages
                }}>
                <StageComponent stage={currentStage}/>
            </ScenarioContext.Provider>
        </div>
    )
};